









































































import { Component, Ref } from 'nuxt-property-decorator'
import { ModalComponentBaseVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import {
  defaultSelectReserveTypeInfoItem,
  SelectReserveTypeInfo,
  SelectReserveTypeInfoItem,
  SelectReserveTypeInfoReserveType
} from '@/components/organisms/ReserveTypeSelectInfo'
import {
  SelectReserveTypeTable,
  SelectReserveTypeTableItem
} from '@/components/organisms/ReserveTypeSelectTable'

import {
  BibliographyRealReserveGroup,
  BibliographyRealReserveSet,
  BibliographyRealReserveSetGroup,
  defaultBibliographyRealReserveSetGroup
} from '@/api'
import { SearchResultPagination } from '@/components/molecules/SearchResultPagination'
import { ReserveBibliography } from '@/components/modals/ModalReserve/ModalReserve.vue'

interface ModalSelectReserveTypeInterface {
  bibliographyRealId: number
  reserveGroupSet: BibliographyRealReserveSetGroup
  onOkClick: (
    bibliographies: ReserveBibliography[],
    reserveSetId?: number,
    reserveGroupId?: number
  ) => void
}

@Component({
  components: {
    SearchResultPagination,
    SelectReserveTypeTable,
    SelectReserveTypeInfo,
    ModalFooter
  }
})
export default class ModalSelectReserveType extends ModalComponentBaseVue {
  @Ref()
  modalFooter!: ModalFooter

  dialog: boolean = false

  isAllSelect: boolean = true

  tableBodyHeight: number = 0

  infoItem: SelectReserveTypeInfoItem = defaultSelectReserveTypeInfoItem()

  tableItems: SelectReserveTypeTableItem[] = []

  bibliographyRealId: number = 0

  reserveGroupSet: BibliographyRealReserveSetGroup = defaultBibliographyRealReserveSetGroup()

  okCallback?: (
    bibliographies: ReserveBibliography[],
    reserveSetId?: number,
    reserveGroupId?: number
  ) => void

  currentReserveIndex: number = 0

  get bibliographyRealIdIndex(): number {
    return this.tableItems.findIndex(
      item => item.bibliographyRealId === this.bibliographyRealId
    )
  }

  get isReserveTypeSet(): boolean {
    return (
      this.infoItem.reserveType.input === SelectReserveTypeInfoReserveType.Set
    )
  }

  get isReserveTypeOne(): boolean {
    return (
      this.infoItem.reserveType.input === SelectReserveTypeInfoReserveType.One
    )
  }

  get useReserve(): (
    | BibliographyRealReserveSet
    | BibliographyRealReserveGroup
  )[] {
    switch (this.infoItem.reserveType.input) {
      case SelectReserveTypeInfoReserveType.Set:
        return this.reserveGroupSet.reserveSets
      case SelectReserveTypeInfoReserveType.Group:
        return this.reserveGroupSet.reserveGroups
      default:
        return []
    }
  }

  get total(): number {
    return this.useReserve.length
  }

  get currentPage(): number {
    return this.currentReserveIndex + 1
  }

  open(params: ModalSelectReserveTypeInterface): void {
    this.bibliographyRealId = params.bibliographyRealId
    this.reserveGroupSet = params.reserveGroupSet
    this.okCallback = params.onOkClick

    this.setItemOneBibliography()

    this.dialog = true
    window.addEventListener('resize', this.calculateTableHeight)

    this.$nextTick(this.calculateTableHeight)
  }

  close(): void {
    this.dialog = false
    this.initialize()
    window.removeEventListener('resize', this.calculateTableHeight)
  }

  initialize(): void {
    this.isAllSelect = true
    this.tableBodyHeight = 0
    this.infoItem = defaultSelectReserveTypeInfoItem()
    this.tableItems = []
    this.bibliographyRealId = 0
    this.reserveGroupSet = defaultBibliographyRealReserveSetGroup()
    this.okCallback = undefined
    this.currentReserveIndex = 0
  }

  calculateTableHeight(): void {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      this.tableBodyHeight = this.calculateTableHeightBase()
    })
  }

  onOkClick(): void {
    if (this.okCallback) {
      this.okCallback(
        this.infoItem.reserveType.input === SelectReserveTypeInfoReserveType.One
          ? [
              {
                bibliographyRealId: this.bibliographyRealId
              }
            ]
          : this.tableItems
              .filter(item => item.isSelected)
              .map((item: SelectReserveTypeTableItem, index: number) => {
                return {
                  bibliographyRealId: item.bibliographyRealId,
                  reserveSetRank:
                    this.infoItem.reserveType.input ===
                      SelectReserveTypeInfoReserveType.Set &&
                    this.infoItem.hasRank.input
                      ? index + 1 // テーブル一覧の順序がそのまま順位になっているのでこれで問題はない
                      : undefined
                }
              }),
        this.infoItem.reserveType.input ===
          SelectReserveTypeInfoReserveType.One ||
          this.infoItem.reserveType.input ===
            SelectReserveTypeInfoReserveType.Group
          ? undefined
          : this.useReserve[this.currentReserveIndex].id,
        this.infoItem.reserveType.input ===
          SelectReserveTypeInfoReserveType.One ||
          this.infoItem.reserveType.input ===
            SelectReserveTypeInfoReserveType.Set
          ? undefined
          : this.useReserve[this.currentReserveIndex].id
      )
    }

    this.close()
  }

  onClickRow(index: number): void {
    if (this.tableItems[index].bibliographyRealId !== this.bibliographyRealId) {
      this.tableItems[index].isSelected = !this.tableItems[index].isSelected
    }
  }

  onChangeReserveType(value: SelectReserveTypeInfoReserveType): void {
    this.infoItem.reserveType.input = value
    this.currentReserveIndex = 0

    if (this.isReserveTypeOne) {
      this.setItemOneBibliography()
    } else {
      this.setItem()
    }

    this.$nextTick(this.calculateTableHeight)
  }

  toggleAllSelect(value: boolean): void {
    this.isAllSelect = value
    this.tableItems.forEach(value => {
      if (value.bibliographyRealId !== this.bibliographyRealId) {
        value.isSelected = this.isAllSelect
      }
    })
  }

  setItemOneBibliography(): void {
    this.infoItem.hasRank.input = true
    this.infoItem = defaultSelectReserveTypeInfoItem()

    if (this.reserveGroupSet.reserveSets[this.currentReserveIndex]) {
      // eslint-disable-next-line standard/computed-property-even-spacing
      const setBibliography = this.reserveGroupSet.reserveSets[
        this.currentReserveIndex
      ].bibliographies.find(
        bibliography =>
          bibliography.bibliographyRealId === this.bibliographyRealId
      )

      if (setBibliography !== undefined) {
        this.tableItems = [
          {
            isSelected: true,
            id: setBibliography.id,
            rank: setBibliography.rank,
            bibliographyRealId: setBibliography.bibliographyRealId,
            bibliographyClass: setBibliography.bibliographyClass,
            prefix: setBibliography.prefix,
            searchType: setBibliography.searchType,
            displayTitle: setBibliography.displayTitle,
            displayAuthor: setBibliography.displayAuthor,
            displayPublisher: setBibliography.displayPublisher,
            displayPublished: setBibliography.displayPublished,
            displaySize: setBibliography.displaySize,
            collectionFlag: setBibliography.collectionFlag,
            shelfCount: setBibliography.shelfCount
          }
        ]
      }
    }

    if (this.reserveGroupSet.reserveGroups[this.currentReserveIndex]) {
      // eslint-disable-next-line standard/computed-property-even-spacing
      const groupBibliography = this.reserveGroupSet.reserveGroups[
        this.currentReserveIndex
      ].bibliographies.find(
        bibliography =>
          bibliography.bibliographyRealId === this.bibliographyRealId
      )

      if (groupBibliography !== undefined) {
        this.tableItems = [
          {
            isSelected: true,
            id: groupBibliography.id,
            rank: 0,
            bibliographyRealId: groupBibliography.bibliographyRealId,
            bibliographyClass: groupBibliography.bibliographyClass,
            prefix: groupBibliography.prefix,
            searchType: groupBibliography.searchType,
            displayTitle: groupBibliography.displayTitle,
            displayAuthor: groupBibliography.displayAuthor,
            displayPublisher: groupBibliography.displayPublisher,
            displayPublished: groupBibliography.displayPublished,
            displaySize: groupBibliography.displaySize,
            collectionFlag: groupBibliography.collectionFlag,
            shelfCount: groupBibliography.shelfCount
          }
        ]
      }
    }
  }

  setItem(): void {
    if (!this.isReserveTypeSet) {
      this.infoItem.hasRank.input = true
    }

    this.infoItem.name = this.useReserve[this.currentReserveIndex].name
    this.infoItem.nameKana = this.useReserve[this.currentReserveIndex].nameKana

    // eslint-disable-next-line standard/computed-property-even-spacing
    this.tableItems = (this.useReserve[
      this.currentReserveIndex
    ] as any).bibliographies.map((bibliography: any) => {
      return {
        isSelected: true,
        id: bibliography.id,
        rank: this.isReserveTypeSet ? bibliography.rank : 0,
        bibliographyRealId: bibliography.bibliographyRealId,
        bibliographyClass: bibliography.bibliographyClass,
        prefix: bibliography.prefix,
        searchType: bibliography.searchType,
        displayTitle: bibliography.displayTitle,
        displayAuthor: bibliography.displayAuthor,
        displayPublisher: bibliography.displayPublisher,
        displayPublished: bibliography.displayPublished,
        displaySize: bibliography.displaySize,
        collectionFlag: bibliography.collectionFlag,
        shelfCount: bibliography.shelfCount
      }
    })
  }

  prev(): void {
    this.pagination(this.currentReserveIndex - 1)
  }

  next(): void {
    this.pagination(this.currentReserveIndex + 1)
  }

  pagination(index: number): void {
    this.currentReserveIndex = index
    this.setItem()
  }

  print(): void {
    const element = document.getElementById('modal-select-reserve-type')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }
}
